import * as React from "react"
import {Grid, makeStyles, Paper} from "@material-ui/core"
import Button from "@material-ui/core/Button"
import {LabelText} from "../../../../styles/AvantTypography"

const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
    },
    paper: {
        padding: theme.spacing(1),
        textAlign: "center",
        color: theme.palette.text.secondary,
    },
}))

interface SSOSyncProps {
    handleSyncClick: () => void
    syncCompleted: string | null
}

const SSOSyncBase: React.FC<SSOSyncProps> = (props) => {
    const classes = useStyles()
    return (
        <Paper elevation={3} className={classes.paper}>
            <Grid container spacing={3}>
                <Grid item xs={12} style={{textAlign: "center"}}>
                    <Button variant="contained" color="primary" onClick={props.handleSyncClick}>Perform Data Synchronization</Button>
                </Grid>
                <Grid item xs={12}>
                    {props.syncCompleted && (<LabelText>Last Full Sync: {new Date(props.syncCompleted).toString()}</LabelText>)}
                    {!props.syncCompleted && (<LabelText>No synchronization has been performed.</LabelText>)}
                </Grid>
            </Grid>
        </Paper>
    )
}

export const SSOSync = React.memo(SSOSyncBase)
